module.exports = __webpack_public_path__ + "static/img/icon-shop-manage-reject.9c99c0d2.png";